import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, EditSignerDialogueHandler } from './types';
import EditSignerContext from './EditSignerContext';

const { ConfirmationDialogue } = vp;

type EditSignerDialogueProps = {
  handleDialogue: DialogueHandler<EditSignerDialogueHandler>;
};

type FC = FunctionComponent<EditSignerDialogueProps>;

const EditSignerDialogue: FC = ({ handleDialogue }: EditSignerDialogueProps) => {
  const { showEditSignerErrorAlert } = useContext(EditSignerContext);

  return useMemo(
    () => (
      <div>
        {/* Edit Signer Error */}
        <ConfirmationDialogue
          isVisible={showEditSignerErrorAlert}
          title="Error! The signer was not edited."
          status="error"
          subTitle="Please provide valid address."
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showEditSignerErrorAlert],
  );
};

export default EditSignerDialogue;
